var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("path",{"d":"M71.82 64.63L37.32.79a1.5 1.5 0 00-2.64 0L.18 64.63a1.52 1.52 0 000 1.49 1.51 1.51 0 001.29.73h69a1.5 1.5 0 001.32-2.22zM4 63.85L36 4.66l32 59.19z","fill":"inherit","data-name":"Layer 1"})));
}

Triangle.defaultProps = {"viewBox":"0 0 72 66.85","stroke":"none"};

module.exports = Triangle;

Triangle.default = Triangle;
